


import React, { useEffect, useState } from 'react';//שימוש בהוק אפקט יביא נתוני מוצר כאשר נטען הרכיב
import { GetProducts, GetProductsByCategoryId } from '../utils/product';//באמצעות הפונקציה יביא רשימה של מוצרים
import { setProducts, setProductsByCategory } from '../features/productsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Typography, Box, Stack, Grid, Button } from "@mui/material";
import Categories from './categories';
import { useParams } from 'react-router-dom';
// import { setProductsPage, setCurrentPage } from '../../actions/productsActions';
import { useNavigate } from 'react-router-dom';
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import SingleProductDesktop from "./SingleProductDesktop";
import CircularProgress from '@mui/material/CircularProgress';
import ProductList from "./ProductList";
import Search from './Search';
import { clearSearch } from "../features/searchSlice";
import { setSelectedCategoryId } from "../features/categoriesSlice"; // אם יש לך



export default function Products() {

    useEffect(() => {
        // כניסה למסך מוצרים: להציג הכל מחדש
        dispatch(clearSearch());
        // אופציונלי: גם לאפס קטגוריה
        dispatch(setSelectedCategoryId(-1));
        setCurrentPage(1);
    }, []);

    // שימוש בשתנה של מערך מוצרים ששמרנו בחלק של המוצרים בסלייס
    const products = useSelector(state => state.product.products);
    const logedUser = useSelector(state => state.user.logedUser);
    const selectedCategoryId = useSelector(state => state.categries.selectedCategoryId);
    const searchTerm = useSelector(state => state.search.searchTerm);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 24;
    const [loading, setLoading] = useState(false);



    console.log('searchTerm', searchTerm);

    // const productsByCategory = useSelector(state => state.product.GetProductsByCategoryId);
    //  const productsView = productsByCategory?.length > 0 ? productsByCategory: products;
    const dispatch = useDispatch();
    // const navigate = useNavigate();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("md"));

    //  const handleOrderClick = () => {
    //      navigate('/order');
    //  };


    //  //  השם חייב להיות תואם למה שהגדרנו בApp.js - products/:categoryId
    // const { categoryId } = useParams();

    //שליפת נתונים: בפונקציה GetProductsList, לאחר שליפת המוצרים מהשרת, אנו מוסיפים לכל מוצר את שדה outOfStock על בסיס הכמות.
    // const GetProductsList = async () => {
    //     const data = await GetProducts();
    //     // Adding outOfStock property based on quantity
    //     const updatedData = data.map(product => ({
    //         ...product,
    //         id: product.id ?? product.ID,   // 🔑 מאחדים מזהה קבוע
    //         outOfStock: product.quantity === 0
    //     }));
    //     dispatch(setProducts(updatedData));
    // }

    const GetProductsList = async () => {
        try {
            setLoading(true);

            const categoryIdToSend = selectedCategoryId === -1 ? undefined : selectedCategoryId;

            const data = await GetProducts({
                categoryId: categoryIdToSend,
                searchTerm: searchTerm?.trim() || undefined,
                page: currentPage,
                pageSize,
            });

            const updatedItems = (data.items || []).filter(Boolean).map((product, idx) => ({
                ...product,
                id: product.id ?? product.ID ?? product.Id ?? idx,
                outOfStock:
                    product.isInStock === false ||
                    product.IsInStock === false ||
                    product.quantity === 0
            }));

            dispatch(setProducts(updatedItems));
            setTotalPages(data.totalPages ?? 1);
        } finally {
            setLoading(false);
        }
    };




    // useEffect(() => {
    //     GetProductsList()        // קריאה ל־API לקבל את המוצרים  
    // }, []);




    useEffect(() => {
        GetProductsList();
    }, [currentPage, selectedCategoryId, searchTerm]);

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedCategoryId, searchTerm]);






    //טיפול בתרחיש שבו המוצרים עדיין נשלפים מה-API
    //מאפשר להציג הודעת טעינה לפני שליפת המוצרים ועיבודם במסך
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 4 }}>
                <CircularProgress size={30} sx={{ mr: 5 }} />
                <Typography variant="h4" sx={{ mr: 5 }}>טוען מוצרים</Typography>
            </Box>
        );
    }

    if (!loading && products?.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 4 }}>
                <Typography variant="h5">לא נמצאו מוצרים</Typography>
            </Box>
        );
    }


    return (
        <>
            {/* <Search /> */}
            {/* <ProductList></ProductList> */}
            <Box display="flex" justifyContent="center" sx={{ p: 10 }}>
                <Typography variant="h4">כלל המוצרים שלנו:</Typography>
            </Box>
            {/* {logedUser?.tipeUser == "admin" && <Button>הוסף מוצר</Button>} */}


            {/* <Box display="flex" justifyContent="center" sx={{ p: 4 }}>
                {Array.from({ length: totalPages }, (_, index) => (
                    <Button
                        key={index}
                        onClick={() => handlePageChange(index + 1)}
                        disabled={index + 1 === currentPage}
                    >
                        {index + 1}
                    </Button>
                ))}
        </Box> */}

            <Container>
                <Grid
                    container
                    spacing={{ xs: 4, md: 4 }}
                    rowSpacing={{ xs: 4, md: 4 }}
                    columnSpacing={{ xs: 4, md: 4 }}
                    justifyContent="center"
                    sx={{ margin: `20px 4px 10px 4px` }}
                    columns={{ xs: 4, sm: 8, md: 12 }}
                >
                    {

                        products.filter(p => p) // הגנה אם בטעות יש null
                            .map((product, idx) => (
                                <Grid
                                    item
                                    key={product.id ?? product.ID ?? `${product.name}-${product.categoryId}-${idx}`}
                                    xs={2}
                                    sm={4}
                                    md={3}
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                >
                                    <SingleProductDesktop product={product} matches={matches} />
                                </Grid>
                            ))


                    }
                </Grid>
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4, gap: 2 }}>
                    <Button
                        variant="outlined"
                        disabled={currentPage <= 1}
                        onClick={() => setCurrentPage(p => p - 1)}
                    >
                        הקודם
                    </Button>

                    <Typography>
                        עמוד {currentPage} מתוך {totalPages}
                    </Typography>

                    <Button
                        variant="outlined"
                        disabled={currentPage >= totalPages}
                        onClick={() => setCurrentPage(p => p + 1)}
                    >
                        הבא
                    </Button>
                </Box>

                {/* <AppPagination setProducts={(p) => setProducts(p)}/> */}
            </Container>
        </>
    );
};


